import React, { useState, useEffect } from "react";
import "./Game3.css";
import "../Others/Game.css";

import Img1 from "../Icon/Nodejs.png";
import Img2 from "../Icon/img2.7a5e691b.png";
import Img3 from "../Icon/fiutter.png";
import Img4 from "../Icon/github (1).png";
import Img5 from "../Icon/swift.png";
import Img6 from "../Icon/xd.png";

const cardImages = [
  { src: Img1, matched: false },
  { src: Img2, matched: false },
  { src: Img3, matched: false },
  { src: Img4, matched: false },
  { src: Img5, matched: false },
  { src: Img6, matched: false },
];

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export default function Game3() {
  const [cards, setCards] = useState([]);
  const [firstChoice, setFirstChoice] = useState(null);
  const [secondChoice, setSecondChoice] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [turns, setTurns] = useState(0);
  const [time, setTime] = useState(0);
  const [gameCompleted, setGameCompleted] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [lastMoveTime, setLastMoveTime] = useState(Date.now());
  const [autoClosed, setAutoClosed] = useState(false);

  useEffect(() => {
    if (gameStarted && !gameCompleted) {
      const interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [gameStarted, gameCompleted]);

  useEffect(() => {
    if (gameStarted && !gameCompleted) {
      const idleCheckInterval = setInterval(() => {
        if (Date.now() - lastMoveTime > 15000) {
          setAutoClosed(true);
          endGame(true); // Indicate that the game is ending due to inactivity
        }
      }, 1000);
      return () => clearInterval(idleCheckInterval);
    }
  }, [gameStarted, gameCompleted, lastMoveTime]);

  useEffect(() => {
    if (firstChoice && secondChoice) {
      setDisabled(true);
      if (firstChoice.src === secondChoice.src) {
        setCards((prevCards) => {
          return prevCards.map((card) => {
            if (card.src === firstChoice.src) {
              return { ...card, matched: true };
            }
            return card;
          });
        });
        resetTurn();
      } else {
        setTimeout(() => resetTurn(), 1000);
      }
    }
  }, [firstChoice, secondChoice]);

  useEffect(() => {
    if (!gameCompleted && cards.every((card) => card.matched)) {
      setGameCompleted(true);
    }
  }, [cards, gameCompleted]);

  const startNewGame = () => {
    const shuffledCards = [...cardImages, ...cardImages];
    shuffleArray(shuffledCards);
    setCards(shuffledCards.map((card) => ({ ...card, id: Math.random() })));
    setFirstChoice(null);
    setSecondChoice(null);
    setDisabled(false);
    setTurns(0);
    setTime(0);
    setGameCompleted(false);
    setGameStarted(true);
    setLastMoveTime(Date.now());
    setAutoClosed(false);
  };

  const endGame = (dueToInactivity = false) => {
    setGameStarted(false);
    setCards([]);
    setFirstChoice(null);
    setSecondChoice(null);
    setDisabled(false);
    setTurns(0);
    setTime(0);
    setGameCompleted(false);
    if (dueToInactivity) {
      setAutoClosed(true);
    }
  };

  const handleChoice = (card) => {
    if (!gameStarted) {
      return;
    }
    setLastMoveTime(Date.now());
    firstChoice ? setSecondChoice(card) : setFirstChoice(card);
    setTurns((prevTurns) => prevTurns + 1);
  };

  const resetTurn = () => {
    setFirstChoice(null);
    setSecondChoice(null);
    setDisabled(false);
  };

  return (
    <div className="Game3-Body">
      <p className="Game3-Text">Memory Match Game</p>
      <div className="Game3-Info">
        <p>Time: {time} seconds</p>
        <p>Turns: {turns}</p>
      </div>
      <div className="Game3-Grid">
        {cards.map((card) => (
          <div
            key={card.id}
            className={`Game3-Card ${
              card === firstChoice || card === secondChoice || card.matched
                ? "flipped"
                : ""
            }`}
            onClick={() => !disabled && !card.matched && handleChoice(card)}
          >
            <img className="front" src={card.src} alt="card front" />
            <div className="back"></div>
          </div>
        ))}
      </div>
      {gameCompleted && (
        <div className="Game3-Result">
          <p>
            Congratulations! You completed the game in {time} seconds with{" "}
            {turns} turns.
          </p>
        </div>
      )}
      {autoClosed && (
        <div className="Game3-Result">
          <p>
            Game over! No movement detected for 15 seconds. The game has been
            closed.
          </p>
        </div>
      )}
      {!gameStarted ? (
        <button className="glow-on-hover" onClick={startNewGame}>
          Start Game
        </button>
      ) : (
        <button className="glow-on-hover" onClick={startNewGame}>
          Restart Game
        </button>
      )}
    </div>
  );
}
